import { defineMessages } from 'react-intl';

export default defineMessages({
  LOGIN: {
    defaultMessage: 'Connexion',
  },

  AUTH_SERVICE_UNAVAILABLE_ERROR: {
    defaultMessage:
      "Le service d'authentification est inaccessible ou a rencontré une erreur inattendue. Merci de réessayer plus tard.",
  },
} as const);
